import { Grid } from '@material-ui/core'
import React from 'react'
import CustomInput from '../../../CustomInput'
import SwitchStatus from '../../../SwitchStatus'
function EditRegionComp({ state, setState }) {
  const { name, regionCode, active } = state

  const data = [
    { label: 'Name', value: name, name: 'name' },
    { label: 'Region Code', value: regionCode, name: 'regionCode' },
  ]
  return (
    <Grid container>
      {data.map((item, index) => (
        <Grid item lg={4} key={index}>
          <CustomInput
            label={item.label}
            icon={item.icon}
            name={item.name}
            value={item.value}
            number={item.number ? true : false}
            form={state}
            setForm={setState}
            formCheck={true}
            type={item.type}
          />
        </Grid>
      ))}
      <SwitchStatus form={state} setForm={setState} value={active} />
    </Grid>
  )
}

export default EditRegionComp
